import { defineMessages } from "react-intl";
import { filter, of, catchError } from "rxjs";
import { isActionOf } from "typesafe-actions";
import { ServerResponseStatus, maxPageSize } from "../../api/types.js";
import { getFilterString } from "../../api/utils.js";
import "immer";
import { UserProfile, Transaction } from "../../contract/pam.js";
import "moment-timezone";
import "@apollo/client/errors";
import "rxjs/operators";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { map, mergeMap } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "@automapper/core";
import "date-fns";
import { UserProfileViewModelKeysTypeName, UserProfileQueryFieldsTypeName } from "../user-profile/constants.js";
import { UserProfileDownloadModel } from "../user-profile/types.js";
import "react-redux";
import "../../user-settings/components/UserSettingsProvider.js";
import "react-oidc-context";
import "react-router";
import "oidc-client-ts";
import "../../auto-mapper/AutoMapperProvider.js";
import "../../redux-folder/async-actions/actions.js";
import "../../redux-folder/async-actions/selectors.js";
import "../../intl/shared-resources/serverResponse.js";
import { BaseEpicsBuilder } from "../../redux-folder/epicsBuilder.js";
import "../../redux-folder/actions.js";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/async-actions/reducers.js";
import "../../redux-folder/download/actions.js";
import "../../redux-folder/download/epics.js";
import "../../ioc-container/inversifyProvider.js";
import "react-hook-form";
import "fast-deep-equal";
import "normalizr";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "../user-profile/components/DataGrid.js";
import "../user-profile/actions.js";
import "../user-profile/epics.js";
import "../user-profile/components/Platform.js";
import "../../components/download/DownloadCsvButton.js";
import "../../components/download/DownloadTemplate.js";
import "../../components/filter/FilterGroupNew.js";
import "../../components/input/validation.js";
import "../../components/input/DatePicker.js";
import "../../components/input/DateRangePicker.js";
import "../../components/input/StyledInput.js";
import "../../components/input/FormInput.js";
import "../../components/input/StyledFormInputHoc.js";
import "../../components/input/DateSinglePicker.localize.js";
import "../../components/input/hooks.js";
import "@mui/material";
import "../../components/filter/dateRangeFilter/DateRangeFilter.js";
import "../../components/filter/date-filter/DateFilter.js";
import "../../components/filter/TextFilterWithDropdown.js";
import "../../components/filter/MultiStepFilterDrawer.js";
import "../../components/filter/dateRangeFilter/MultiStepFilterDatePicker.js";
import "../../components/select/Select.js";
import "../../components/filter/TextFilter.js";
import "../../components/filter/valueRangeFilter/ValueRangeFilter.js";
import "../../components/filter/dateRangeFilter/localized.js";
import "../../components/filter/dateRangeFilter/DateRangeHistoricalFilter.js";
import "../../components/filter/MultiStepFilterApplyButton.js";
import "../../components/filter/MultiStepFilterInput.js";
import "../../components/filter/MultiStepFilterHoc.js";
import "../../components/chip/ChipRenderer.js";
import "../../components/select/selectStyle.js";
import "../../components/select/MultiSelectFooter.js";
import "../../components/select/MultiSelect.js";
import "../../components/select/MultiSelectItem.js";
import "../../components/select/SelectArrowIcon.js";
import "../../components/select/VirtualizedMultiSelectOptionList.js";
import "../../components/select/SingleSelect.js";
import "../../components/select/MultiSelectWithExclude.js";
import "../../components/select/MultiSelectTextCounterWithTooltip.js";
import "../../components/filter/PhoneFilter.js";
import "../brand-license/constants.js";
import "../country/components/CountryFilter.js";
import "../brand-license/components/BrandProvider.js";
import "../../components/alerts/NoAccessInfoMessage.js";
import "../brand-license/components/LicenseSelect.js";
import "../brand-license/components/BrandSelect.js";
import "../../components/circle-box/CircleBoxWithText.js";
import "../../components/label/EmptyLabel.js";
import "../../components/label/LabelHoc.js";
import "../../components/tooltip/Tooltip.js";
import "../../components/tooltip/AutoAdjustedWidthTooltip.styles.js";
import "../../components/tooltip/AutoAdjustedComplexTooltip.styles.js";
import "../../components/tooltip/MultiLineAutoAdjustedWidthTooltip.js";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import "../../style/hooks.js";
import "../../components/circle-box/CircleBox.js";
import "../user-profile/components/Filters.js";
import "../user-profile/components/P2PStatusCell.js";
import "../user-profile/components/UserDetailsWDBalance.js";
import "../user-profile/components/ReferralLinkButton.js";
import "../user-profile/components/PlayerIdAutocomplete.js";
import { fileActions } from "../../redux-folder/file/actions.js";
import { getMessageActions, messageActions } from "../../redux-folder/message/actions.js";
import { transactionActions } from "./actions.js";
import { TransactionDownloadModel } from "./types.js";
const localized = defineMessages({
  downloadFailure: {
    id: "TransactionActionsEpicsBuilder_failureMessage",
    defaultMessage: "Failed to download Agent Report"
  },
  totalCountErrorMessage: {
    id: "TransactionActionsEpicsBuilder_totalCountErrorMessage",
    defaultMessage: "Total count of downloaded items cannot be more than {maxPageSize}"
  },
  retrySuccessful: {
    id: "TransactionActionsEpicsBuilder_retrySuccessful",
    defaultMessage: "Transaction successfully re-tried"
  },
  retryFailed: {
    id: "TransactionActionsEpicsBuilder_retryFailed",
    defaultMessage: "Failed to re-try transaction"
  },
  deleteSuccessful: {
    id: "TransactionActionsEpicsBuilder_deleteSuccessful",
    defaultMessage: "Transaction successfully deleted"
  },
  deleteFailed: {
    id: "TransactionActionsEpicsBuilder_deleteFailed",
    defaultMessage: "Failed to delete transaction"
  },
  downloadP2PBulkTemplateFailed: {
    id: "TransactionActionsEpicsBuilder_downloadP2PBulkTemplateFailed",
    defaultMessage: "Failed to download P2P bulk transfer template"
  }
});
class TransactionEpicsBuilder extends BaseEpicsBuilder {
  _service;
  _fileFactory;
  _templateFactory;
  _mapper;
  _userProfileService;
  _transactionEntityType = "Transaction";
  _userProfileEntityType = "UserProfile";
  _messageActions;
  constructor(service, fileFactory, templateFactory, mapper, userProfile) {
    super();
    this._service = service;
    this._fileFactory = fileFactory;
    this._templateFactory = templateFactory;
    this._mapper = mapper;
    this._userProfileService = userProfile;
    this._messageActions = getMessageActions();
  }
  buildEpicList() {
    return [
      this.buildTransactionDownloadEpic(),
      this.buildTransactionDownloadSuccessEpic(),
      this.buildTransactionDownloadFailureEpic(),
      this.buildRetryTransactionRequestEpic(),
      this.buildRetryTransactionSuccessEpic(),
      this.buildRetryTransactionFailedEpic(),
      this.buildDeleteTransactionRequestEpic(),
      this.buildDeleteTransactionSuccessEpic(),
      this.buildDeleteTransactionFailedEpic(),
      this.buildDownloadBulkP2PTransferTemplateEpic()
    ];
  }
  buildRetryTransactionRequestEpic() {
    return this.buildRequestEpic(
      transactionActions.retryTransaction,
      (payload) => this._service.retryTransaction(payload)
    );
  }
  buildRetryTransactionSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(transactionActions.retryTransaction.success)),
      map(
        () => messageActions.saveMessage({
          message: localized.retrySuccessful,
          mode: "success"
        })
      )
    );
  }
  buildRetryTransactionFailedEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(transactionActions.retryTransaction.failure)),
      map(
        () => messageActions.saveMessage({
          message: localized.retryFailed,
          mode: "error"
        })
      )
    );
  }
  buildDeleteTransactionRequestEpic() {
    return this.buildRequestEpic(
      transactionActions.deleteTransaction,
      (payload) => this._service.deleteTransaction(payload)
    );
  }
  buildDeleteTransactionSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(transactionActions.deleteTransaction.success)),
      map(
        () => messageActions.saveMessage({
          message: localized.deleteSuccessful,
          mode: "success"
        })
      )
    );
  }
  buildDeleteTransactionFailedEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(transactionActions.deleteTransaction.failure)),
      map(
        () => messageActions.saveMessage({
          message: localized.deleteFailed,
          mode: "error"
        })
      )
    );
  }
  buildTransactionDownloadEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(transactionActions.transactionDownloadCsv.request)),
      mergeMap((action) => {
        const { filter: filter2, fields, filename, worksheetKeys, userWorksheetKeys, headers } = action.payload;
        const fetchPayload = {
          type: this._transactionEntityType,
          filter: filter2,
          fields
        };
        const failureObservable = of(
          transactionActions.transactionDownloadCsv.failure({
            message: localized.downloadFailure,
            mode: "error"
          })
        );
        return this._service.get(fetchPayload).pipe(
          mergeMap((response) => {
            let result = this.getFailedMessage(response);
            if (result === null) {
              const items = response?.responsePayload?.items;
              const uids = items?.map((i) => i?.uid)?.filter((i) => i);
              const userServiceRequestPayload = this.getUserProfileFetchPayload(userWorksheetKeys, uids);
              if (userWorksheetKeys?.length && uids?.length) {
                result = this._userProfileService.get(userServiceRequestPayload).pipe(
                  mergeMap((userResponse) => {
                    let userResult = this.getFailedMessage(userResponse);
                    if (userResult === null) {
                      const data = this.getWorksheetData(
                        items,
                        userResponse?.responsePayload?.items
                      );
                      userResult = this.downloadFile(
                        [...worksheetKeys, ...userWorksheetKeys],
                        data,
                        headers,
                        filename
                      );
                    }
                    return userResult;
                  })
                );
              } else {
                const worksheetData = this.getWorksheetData(items);
                result = this.downloadFile(worksheetKeys, worksheetData, headers, filename);
              }
            }
            return result;
          }),
          catchError(() => failureObservable)
        );
      })
    );
  }
  buildTransactionDownloadSuccessEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(transactionActions.transactionDownloadCsv.success)),
      map((action) => {
        const { filename, arrayBuffer } = action.payload;
        return fileActions.download({
          file: new Blob([arrayBuffer]),
          title: filename,
          type: "csv"
        });
      })
    );
  }
  buildTransactionDownloadFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(transactionActions.transactionDownloadCsv.failure)),
      map((action) => this._messageActions.saveMessage(action.payload))
    );
  }
  getFailedMessage(response) {
    let result = null;
    if (response?.status !== ServerResponseStatus.Success) {
      result = of(
        transactionActions.transactionDownloadCsv.failure({
          message: localized.downloadFailure,
          mode: "error"
        })
      );
    } else if (response?.responsePayload?.total > maxPageSize) {
      result = of(
        transactionActions.transactionDownloadCsv.failure({
          message: localized.totalCountErrorMessage,
          values: { maxPageSize: `${maxPageSize}` },
          mode: "error"
        })
      );
    }
    return result;
  }
  getUserProfileFetchPayload(userWorksheetKeys, uids) {
    const userQueryFields = this._mapper.map(
      userWorksheetKeys,
      UserProfileViewModelKeysTypeName,
      UserProfileQueryFieldsTypeName
    );
    const uidKey = "uid";
    const pageFilterKey = "page";
    const sizeFilterKey = "size";
    return {
      type: this._userProfileEntityType,
      filter: getFilterString(
        "",
        true,
        { key: uidKey, value: [...new Set(uids)].join("|") },
        { key: pageFilterKey, value: "1" },
        { key: sizeFilterKey, value: `${maxPageSize}` }
      ),
      fields: userQueryFields
    };
  }
  getWorksheetData(transactions, users = []) {
    return transactions?.map((i) => {
      const user = users?.length ? this._mapper.map(
        users.find((u) => u.uid === i.uid),
        UserProfile,
        UserProfileDownloadModel
      ) : {};
      const downloadModel = this._mapper.map(i, Transaction, TransactionDownloadModel);
      return {
        ...user,
        ...downloadModel
      };
    });
  }
  downloadFile(keys, data, headers, filename) {
    return this._fileFactory.createFile(data, keys, headers).pipe(
      map((arrayBuffer) => transactionActions.transactionDownloadCsv.success({ arrayBuffer, filename })),
      catchError(
        () => of(
          transactionActions.transactionDownloadCsv.failure({
            message: localized.downloadFailure,
            mode: "error"
          })
        )
      )
    );
  }
  buildDownloadBulkP2PTransferTemplateEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(transactionActions.downloadBulkP2PTransferTemplate)),
      mergeMap(
        () => this._templateFactory.createFile().pipe(
          map(
            (doc) => fileActions.download({
              file: new Blob([doc]),
              title: `bulk_transfer_template`,
              type: "xlsx"
            })
          ),
          catchError(
            () => of(
              messageActions.saveMessage({
                message: localized.downloadP2PBulkTemplateFailed,
                mode: "error"
              })
            )
          )
        )
      )
    );
  }
}
export {
  TransactionEpicsBuilder,
  localized
};
//# sourceMappingURL=epic.js.map
